import { render, staticRenderFns } from "./WebWidget.vue?vue&type=template&id=578be498&scoped=true&"
import script from "./WebWidget.vue?vue&type=script&lang=js&"
export * from "./WebWidget.vue?vue&type=script&lang=js&"
import style0 from "./WebWidget.vue?vue&type=style&index=0&id=578be498&prod&scoped=true&lang=css&"
import style1 from "./WebWidget.vue?vue&type=style&index=1&id=578be498&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578be498",
  null
  
)

export default component.exports